import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[trimOnBlur]'
})
export class TrimOnBlurDirective {
  constructor(private ngControl: NgControl) {}

  @HostListener('blur') onBlur(): void {
    const value = this.ngControl.control?.value;

    if (typeof value === 'string') {
      // Set to null if the trimmed value is an empty string
      const trimmedValue = value.replace(/\s+/g, '')?.trim() || null;

      this.ngControl.control.setValue(trimmedValue, { emitEvent: false });
    }
  }
}
